(() => {
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
  const scrollLock = {
    count: 0,
    acquire() {
      if (this.count++ === 0) {
        this.overflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }
    },
    release() {
      if (this.count > 0 && --this.count === 0) document.body.style.overflow = this.overflow;
    },
  };
  if (!customElements.get('chastar-product-information')) {
    customElements.define('chastar-product-information', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.productInfo = this.closest('product-info');
        this.sizeDialog = this.querySelector('[data-size-dialog]');
        this.accordions = new Map();
        this.querySelectorAll('.chastar-dune__accordion').forEach(details => {
          this.accordions.set(details, { expanded: details.open, sequence: 0 });
          details.dataset.expanded = String(details.open);
          details.querySelector('summary').setAttribute('aria-expanded', String(details.open));
        });
        if (this.dataset.editorPreview === 'true') {
          this.addEventListener('submit', event => { event.preventDefault(); event.stopImmediatePropagation(); }, { ...options, capture: true });
          this.querySelector('.chastar-dune__checkout')?.setAttribute('inert', '');
        }
        this.addEventListener('click', event => {
          const summary = event.target.closest('.chastar-dune__accordion > summary');
          if (summary && this.contains(summary)) { event.preventDefault(); this.toggleAccordion(summary.parentElement); }
          if (event.target.closest('[data-size-open]') && !this.sizeDialog?.open) {
            this.sizeDialog?.showModal();
            if (this.sizeDialog?.open) { scrollLock.acquire(); this.sizeLocked = true; }
          }
          if (event.target.closest('[data-size-close]')) this.sizeDialog?.close();
        }, options);
        this.sizeDialog?.addEventListener('click', event => {
          const rect = this.sizeDialog.getBoundingClientRect();
          if (event.target === this.sizeDialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.sizeDialog.close();
        }, options);
        this.sizeDialog?.addEventListener('close', () => {
          if (this.sizeLocked) scrollLock.release();
          this.sizeLocked = false;
        }, options);
        const inventory = this.querySelector(`#Inventory-${this.dataset.sectionId}`);
        this.stockObserver = new MutationObserver(() => {
          if (!inventory.classList.contains('hidden')) return;
          inventory.classList.remove('hidden');
          const stock = inventory.querySelector('.chastar-dune__stock');
          stock?.classList.remove('chastar-dune__stock--in');
          stock?.classList.add('chastar-dune__stock--out');
          const label = stock?.querySelector('span:last-child');
          if (label) label.textContent = this.dataset.unavailable;
        });
        if (inventory) this.stockObserver.observe(inventory, { attributes: true, attributeFilter: ['class'] });
        const quantity = this.querySelector('.quantity__input');
        this.quantityObserver = new MutationObserver(() => this.productInfo?.setQuantityBoundries?.());
        if (quantity) this.quantityObserver.observe(quantity, { attributes: true, attributeFilter: ['data-min', 'data-max', 'data-cart-quantity', 'step'] });
      }
      async toggleAccordion(details) {
        const state = this.accordions.get(details);
        if (!state) return;
        const content = details.querySelector('.chastar-dune__content');
        const summary = details.querySelector('summary');
        const startHeight = details.getBoundingClientRect().height;
        const opacity = details.open ? getComputedStyle(content).opacity : '0';
        state.heightAnimation?.cancel();
        state.contentAnimation?.cancel();
        state.expanded = !state.expanded;
        const sequence = ++state.sequence;
        details.open = true;
        details.dataset.expanded = String(state.expanded);
        summary.setAttribute('aria-expanded', String(state.expanded));
        content.inert = !state.expanded;
        const endHeight = summary.getBoundingClientRect().height + (state.expanded ? content.getBoundingClientRect().height : 0);
        details.setAttribute('data-animating', '');
        const duration = reducedMotion() ? 0 : 280;
        state.heightAnimation = details.animate([{ height: `${startHeight}px` }, { height: `${endHeight}px` }], { duration, easing: 'cubic-bezier(.22,.8,.25,1)', fill: 'forwards' });
        state.contentAnimation = content.animate([{ opacity, transform: state.expanded ? 'translateY(-6px)' : 'none' }, { opacity: state.expanded ? 1 : 0, transform: state.expanded ? 'none' : 'translateY(-6px)' }], { duration, easing: 'ease-out', fill: 'forwards' });
        try { await state.heightAnimation.finished; } catch {}
        if (sequence !== state.sequence) return;
        details.open = state.expanded;
        state.heightAnimation.cancel();
        state.contentAnimation.cancel();
        details.removeAttribute('data-animating');
      }
      disconnectedCallback() {
        if (this.sizeLocked) scrollLock.release();
        this.sizeDialog?.close();
        this.sizeLocked = false;
        this.controller?.abort();
        this.controller = null;
        this.stockObserver?.disconnect();
        this.quantityObserver?.disconnect();
        this.accordions?.forEach((state, details) => {
          ++state.sequence;
          state.heightAnimation?.cancel();
          state.contentAnimation?.cancel();
          details.open = state.expanded;
          details.removeAttribute('data-animating');
        });
      }
    });
  }
  if (!customElements.get('chastar-dune-gallery')) {
    customElements.define('chastar-dune-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.image = this.querySelector('.chastar-dune-gallery__image');
        this.viewport = this.querySelector('[data-gallery-viewport]');
        this.rail = this.querySelector('[data-gallery-rail]');
        this.dialog = this.querySelector('[data-zoom-dialog]');
        this.zoomImage = this.querySelector('[data-zoom-image]');
        this.zoomTarget = this.querySelector('[data-zoom-toggle]');
        this.zoomScroll = this.querySelector('[data-zoom-scroll]');
        this.zoomCanvas = this.querySelector('[data-zoom-canvas]');
        this.media = JSON.parse(this.querySelector('[data-gallery-media]')?.textContent || '[]');
        this.index = Math.max(0, this.media.findIndex(item => item.key === this.dataset.initialMedia));
        this.desiredIndex = this.index;
        this.sequence = 0;
        this.zoomSequence = 0;
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (performance.now() < (this.suppressClickUntil || 0)) { event.preventDefault(); return; }
          if (button.dataset.mediaId) this.showMedia(button.dataset.mediaId);
          if (button.hasAttribute('data-gallery-prev')) this.showIndex(this.desiredIndex - 1, -1);
          if (button.hasAttribute('data-gallery-next')) this.showIndex(this.desiredIndex + 1, 1);
          if (button.hasAttribute('data-gallery-enlarge')) this.openZoom(event);
          if (button.hasAttribute('data-gallery-close')) this.closeZoom();
          if (button.hasAttribute('data-zoom-toggle')) this.toggleZoom(event);
        }, options);
        for (const area of [this.viewport, this.rail]) {
          area?.addEventListener('touchstart', event => {
            this.touch = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY, area } : null;
          }, { ...options, passive: true });
          area?.addEventListener('touchcancel', () => { this.touch = null; }, { ...options, passive: true });
          area?.addEventListener('touchend', event => {
            if (!this.touch || this.touch.area !== area || !event.changedTouches.length) return;
            const dx = event.changedTouches[0].clientX - this.touch.x;
            const dy = event.changedTouches[0].clientY - this.touch.y;
            this.touch = null;
            if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.4) {
              this.suppressClickUntil = performance.now() + 500;
              this.showIndex(this.desiredIndex + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
            }
          }, { ...options, passive: true });
        }
        this.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.showIndex(this.desiredIndex + (event.key === 'ArrowRight' ? 1 : -1), event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        this.dialog?.addEventListener('cancel', event => { event.preventDefault(); this.closeZoom(); }, options);
        this.dialog?.addEventListener('click', event => {
          if (event.target === this.dialog || event.target === this.zoomScroll || event.target === this.zoomCanvas) this.closeZoom();
        }, options);
        this.dialog?.addEventListener('close', () => this.restoreZoom(), options);
        this.productInfo = this.closest('product-info');
        this.productInfo?.addEventListener('change', event => {
          if (!event.target.closest('variant-selects')) return;
          const fieldset = event.target.closest('[data-colour-option]');
          if (!fieldset) return;
          const selected = fieldset.querySelector('input:checked');
          const colourIndex = Number(selected?.dataset.colourIndex);
          const direction = Number.isFinite(this.lastColourIndex) && colourIndex < this.lastColourIndex ? -1 : 1;
          this.lastColourIndex = colourIndex;
          this.pendingDirection = direction;
          if (selected?.dataset.previewMediaId) this.showMedia(selected.dataset.previewMediaId, direction);
        }, options);
        this.lastColourIndex = Number(this.productInfo?.querySelector('[data-colour-option] input:checked')?.dataset.colourIndex || 0);
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (String(data.sectionId) !== this.dataset.sectionId) return;
            const script = data.html?.querySelector('chastar-dune-gallery [data-gallery-media]');
            if (script) {
              const next = JSON.parse(script.textContent || '[]');
              if (next.map(item => item.key).join() !== this.media.map(item => item.key).join()) {
                const current = this.media[this.index]?.key;
                this.media = next;
                this.index = Math.max(0, next.findIndex(item => item.key === current));
                this.desiredIndex = this.index;
                const rail = data.html.querySelector('[data-gallery-rail]');
                if (this.rail && rail) this.rail.innerHTML = rail.innerHTML;
              }
            }
            if (data.variant?.featured_media?.id) this.showMedia(String(data.variant.featured_media.id), this.pendingDirection);
            this.pendingDirection = undefined;
          });
        }
        this.resizeObserver = new ResizeObserver(() => this.updateSticky());
        this.resizeObserver.observe(this);
        window.addEventListener('resize', () => {
          this.updateSticky();
          if (this.dialog?.open && !this.closing) {
            this.zoomAnimation?.cancel();
            this.layoutZoom(this.zoomPoint || { x: .5, y: .5 });
          }
        }, options);
        this.updateControls();
        this.updateSticky();
      }
      updateSticky() {
        const offset = parseFloat(getComputedStyle(this).getPropertyValue('--cd-sticky-offset')) || 0;
        this.style.setProperty('--cd-sticky-top', `${Math.min(offset, window.innerHeight - this.offsetHeight - 24)}px`);
      }
      ensureSwipe() {
        if (!this.swipe && this.image && window.ChastarImageSwipe) this.swipe = new window.ChastarImageSwipe(this.image, { viewport: this.viewport, initialIndex: this.index, initialKey: this.media[this.index]?.key, duration: 320 });
      }
      showMedia(key, direction) {
        const index = this.media.findIndex(item => item.key === String(key));
        if (index >= 0) return this.showIndex(index, direction);
      }
      async showIndex(index, direction) {
        if (!this.image || !this.media.length || this.closing) return false;
        index = clamp(index, 0, this.media.length - 1);
        this.desiredIndex = index;
        const next = this.media[index];
        const sequence = ++this.sequence;
        this.ensureSwipe();
        const status = this.querySelector('[data-gallery-status]');
        if (status) status.textContent = '';
        this.viewport.setAttribute('aria-busy', 'true');
        let success = false;
        if (this.swipe) success = await this.swipe.show(next, { index, direction });
        else {
          const preload = new Image();
          preload.src = next.src;
          try {
            await Promise.race([preload.decode(), new Promise((_, reject) => setTimeout(reject, 10000))]);
            if (sequence === this.sequence) {
              this.image.srcset = next.srcset || '';
              this.image.sizes = next.sizes || '';
              this.image.src = next.src;
              this.image.alt = next.alt || '';
              this.image.width = next.width;
              this.image.height = next.height;
              success = true;
            }
          } catch {}
        }
        if (sequence !== this.sequence) return false;
        this.viewport.removeAttribute('aria-busy');
        if (success) {
          this.index = index;
          if (this.dataset.adapt === 'true') this.style.setProperty('--cd-image-ratio', `${next.width}/${next.height}`);
          this.updateControls();
          if (this.dialog?.open && !this.closing) {
            this.zoomAnimation?.cancel();
            this.zoomImage.style.transform = '';
            this.zoomImage.src = this.image.currentSrc || next.src;
            this.zoomed = false;
            this.layoutZoom({ x: .5, y: .5 });
            this.loadLarge(++this.zoomSequence);
          }
        } else {
          this.desiredIndex = this.index;
          if (status) status.textContent = this.dataset.imageError;
        }
        return success;
      }
      updateControls() {
        const current = this.media[this.index];
        this.querySelectorAll('[data-media-id]').forEach(button => button.setAttribute('aria-current', String(button.dataset.mediaId === current?.key)));
        this.querySelectorAll('[data-gallery-prev]').forEach(button => { button.disabled = this.index <= 0; });
        this.querySelectorAll('[data-gallery-next]').forEach(button => { button.disabled = this.index >= this.media.length - 1; });
        const count = this.querySelector('[data-gallery-count]');
        if (count) count.textContent = `${this.index + 1} / ${this.media.length}`;
        const active = this.rail?.querySelector('[aria-current=true]');
        if (active) {
          const rect = active.getBoundingClientRect();
          const rail = this.rail.getBoundingClientRect();
          const dx = rect.left < rail.left ? rect.left - rail.left : rect.right > rail.right ? rect.right - rail.right : 0;
          if (dx) this.rail.scrollBy({ left: dx, behavior: reducedMotion() ? 'auto' : 'smooth' });
        }
      }
      imageRect() {
        const rect = this.image.getBoundingClientRect();
        const media = this.media[this.index];
        const ratio = (media?.width || this.image.naturalWidth) / (media?.height || this.image.naturalHeight);
        const cover = getComputedStyle(this.image).objectFit === 'cover';
        let width = rect.width;
        let height = width / ratio;
        if ((!cover && height > rect.height) || (cover && height < rect.height)) { height = rect.height; width = height * ratio; }
        return { left: rect.left + (rect.width - width) / 2, top: rect.top + (rect.height - height) / 2, width, height };
      }
      layoutZoom(point) {
        const media = this.media[this.index];
        this.zoomKey = media.key;
        const ratio = media.width / media.height;
        const scale = this.zoomed ? parseFloat(getComputedStyle(this).getPropertyValue('--cd-zoom-scale')) || 2 : 1;
        const fittedWidth = Math.min(this.zoomScroll.clientWidth - 48, (this.zoomScroll.clientHeight - 128) * ratio);
        const width = Math.max(1, fittedWidth * scale);
        const height = width / ratio;
        this.zoomPoint = point;
        this.dialog.dataset.zoomed = String(Boolean(this.zoomed));
        this.zoomTarget.style.width = `${width}px`;
        this.zoomTarget.style.height = `${height}px`;
        this.zoomTarget.setAttribute('aria-pressed', String(Boolean(this.zoomed)));
        this.zoomTarget.setAttribute('aria-label', this.zoomed ? this.zoomTarget.dataset.zoomOut : this.zoomTarget.dataset.zoomIn);
        this.zoomImage.style.width = `${width}px`;
        this.zoomImage.style.height = `${height}px`;
        this.zoomImage.alt = media.alt || '';
        this.zoomCanvas.style.width = `${Math.max(width + 48, this.zoomScroll.clientWidth)}px`;
        this.zoomCanvas.style.height = `${Math.max(height + 120, this.zoomScroll.clientHeight)}px`;
        this.zoomScroll.scrollLeft = this.zoomed ? this.zoomTarget.offsetLeft + point.x * width - this.zoomScroll.clientWidth / 2 : 0;
        this.zoomScroll.scrollTop = this.zoomed ? this.zoomTarget.offsetTop + point.y * height - this.zoomScroll.clientHeight / 2 : 0;
      }
      transformBetween(from, to) {
        return `translate(${from.left - to.left}px,${from.top - to.top}px) scale(${from.width / to.width},${from.height / to.height})`;
      }
      async openZoom() {
        if (!this.dialog || this.dialog.open || !this.media.length || this.viewport.hasAttribute('aria-busy')) return;
        const origin = this.imageRect();
        this.zoomImage.src = this.image.currentSrc || this.media[this.index].src;
        this.dialog.showModal();
        scrollLock.acquire();
        this.zoomLocked = true;
        this.zoomed = false;
        this.layoutZoom({ x: .5, y: .5 });
        const destination = this.zoomImage.getBoundingClientRect();
        this.image.style.visibility = 'hidden';
        this.closing = false;
        const token = ++this.zoomSequence;
        const duration = reducedMotion() ? 0 : 380;
        this.zoomAnimation = this.zoomImage.animate([{ transform: this.transformBetween(origin, destination) }, { transform: 'none' }], { duration, easing: 'cubic-bezier(.22,.8,.25,1)' });
        this.backgroundAnimation = this.dialog.animate([{ backgroundColor: 'transparent' }, { backgroundColor: getComputedStyle(this.dialog).backgroundColor }], { duration });
        this.querySelector('[data-zoom-controls]').animate([{ opacity: 0 }, { opacity: 1 }], { duration });
        this.loadLarge(token);
        try { await this.zoomAnimation.finished; } catch {}
      }
      async toggleZoom(event) {
        if (!this.dialog?.open || this.closing) return;
        const current = this.zoomImage.getBoundingClientRect();
        const point = event.detail === 0 ? { x: .5, y: .5 } : { x: clamp((event.clientX - current.left) / current.width, 0, 1), y: clamp((event.clientY - current.top) / current.height, 0, 1) };
        this.zoomAnimation?.cancel();
        this.zoomed = !this.zoomed;
        this.layoutZoom(this.zoomed ? point : { x: .5, y: .5 });
        const destination = this.zoomImage.getBoundingClientRect();
        this.zoomAnimation = this.zoomImage.animate([{ transform: this.transformBetween(current, destination) }, { transform: 'none' }], { duration: reducedMotion() ? 0 : 340, easing: 'cubic-bezier(.22,.8,.25,1)' });
        try { await this.zoomAnimation.finished; } catch {}
      }
      async loadLarge(token) {
        const media = this.media[this.index];
        if (!media?.large || media.large === this.zoomImage.src) return;
        const preload = new Image();
        preload.src = media.large;
        try {
          await Promise.race([preload.decode(), new Promise((_, reject) => setTimeout(reject, 10000))]);
          if (this.dialog.open && token === this.zoomSequence && !this.closing) this.zoomImage.src = media.large;
        } catch {}
      }
      async closeZoom() {
        if (!this.dialog?.open || this.closing) return;
        this.closing = true;
        ++this.zoomSequence;
        if (this.viewport.hasAttribute('aria-busy')) {
          ++this.sequence;
          const activeIndex = this.media.findIndex(item => item.key === this.swipe?.key);
          if (activeIndex >= 0) this.index = activeIndex;
          this.desiredIndex = this.index;
          this.swipe?.cancel();
          this.viewport.removeAttribute('aria-busy');
          this.updateControls();
          if (this.zoomKey !== this.media[this.index].key) {
            this.zoomAnimation?.cancel();
            this.zoomImage.src = this.media[this.index].src;
            this.zoomed = false;
            this.layoutZoom({ x: .5, y: .5 });
          }
        }
        const current = this.zoomImage.getBoundingClientRect();
        this.zoomAnimation?.cancel();
        this.backgroundAnimation?.cancel();
        this.zoomImage.style.transform = '';
        const destination = this.zoomImage.getBoundingClientRect();
        const origin = this.imageRect();
        const duration = reducedMotion() ? 0 : 340;
        this.zoomAnimation = this.zoomImage.animate([{ transform: this.transformBetween(current, destination) }, { transform: this.transformBetween(origin, destination) }], { duration, easing: 'cubic-bezier(.22,.8,.25,1)', fill: 'forwards' });
        this.backgroundAnimation = this.dialog.animate([{ backgroundColor: getComputedStyle(this.dialog).backgroundColor }, { backgroundColor: 'transparent' }], { duration, fill: 'forwards' });
        this.querySelector('[data-zoom-controls]').animate([{ opacity: 1 }, { opacity: 0 }], { duration, fill: 'forwards' });
        try { await this.zoomAnimation.finished; } catch {}
        if (this.dialog.open) this.dialog.close();
        this.restoreZoom();
      }
      restoreZoom() {
        this.zoomAnimation?.cancel();
        this.backgroundAnimation?.cancel();
        this.querySelector('[data-zoom-controls]')?.getAnimations().forEach(animation => animation.cancel());
        if (this.image) this.image.style.visibility = '';
        if (this.zoomImage) this.zoomImage.style.transform = '';
        if (this.zoomLocked) scrollLock.release();
        this.zoomLocked = false;
        this.closing = false;
      }
      disconnectedCallback() {
        ++this.sequence;
        ++this.zoomSequence;
        this.dialog?.close();
        this.restoreZoom();
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.unsubscribe?.();
        this.swipe?.destroy();
        this.swipe = null;
      }
    });
  }
})();
